export default function ResultsSection() {
  const stats = [
    {
      value: "31%",
      label: "Average conversion rate",
    },
    {
      value: "24/7",
      label: "Availability",
    },
    {
      value: "<30 sec",
      label: "Lead response time",
    },
    {
      value: "5X",
      label: "More meetings per $ invested",
    },
  ];

  return (
    <section className="py-20 lg:py-24 bg-[#F8FAFC] border-b border-slate-200/80">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-slate-900 tracking-tight leading-[1.15] mb-14">
          Results EchoLeads reports
        </h2>

        {/* 4 Big Metrics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((item, idx) => (
            <div key={idx} className="space-y-5">
              {/* Individual Golden Line */}
              <div className="h-[2.5px] w-full bg-[#F2A339]" />
              <div className="text-4xl sm:text-5xl lg:text-[60px] font-extrabold text-slate-900 tracking-tight font-heading leading-none">
                {item.value}
              </div>
              <div className="text-sm sm:text-base font-medium text-slate-600">
                {item.label}
              </div>
            </div>
          ))}
        </div>

        {/* Footnote */}
        <div className="pt-10 text-xs sm:text-sm text-slate-500">
          Figures as reported by EchoLeads. Actual results depend on your leads, offer and setup.
        </div>
      </div>
    </section>
  );
}
